import React from "react"
import Hero from "./Hero"
import logo from "../images/spot-workers-logo.svg"
import screenshot from "../images/mobile-spot-workers-hdr.png"
import useWindowSize from "../lib/useWindowSize"

function ReportersHero() {
  const size = useWindowSize()

  return (
    <Hero>
      <div className="hero-copy">
        <img src={logo} alt="Spot Mobile" />
        <p>Unlocking your mobile workers’ full potential.</p>
      </div>
      <div
        className="hero-image"
        style={{ paddingTop: size.width >= 750 ? 32 : 0 }}
      >
        <img src={screenshot} alt="Spot Workers" />
      </div>
    </Hero>
  )
}

export default ReportersHero
